import { TAddOn, USER_COHORT } from "@/components/Checkout/types.checkout";

export function isAddOnForFounder(
  addOn: Pick<TAddOn, "user_cohorts">,
): boolean {
  if (!addOn) return false;

  const raw = (addOn as { user_cohorts?: unknown }).user_cohorts;

  const cohorts = Array.isArray(raw) ? raw : raw != null ? [raw] : [];

  return cohorts.some(
    (cohort) => String(cohort).toLowerCase() === USER_COHORT.founders,
  );
}
